import { InfoTooltip } from './InfoTooltip';

/**
 * The shared explanation of the two caller scopes — what each means and when to use it.
 * Used next to the scope field in both the tool form and the test runner.
 */
export const ScopeHelp = () => (
  <InfoTooltip label="What is scope?">
    <p>How sure the agent is about who it’s talking to:</p>
    <dl>
      <dt>partner_user</dt>
      <dd>
        Knows which contact this is, but hasn’t confirmed they really are that person. Fine for low-risk
        actions.
      </dd>
      <dt>partner_user:verified</dt>
      <dd>
        Confirmed the contact really is who they say. Require this for sensitive actions like sharing
        personal info or changing an account.
      </dd>
    </dl>
  </InfoTooltip>
);
